__turbopack_context__.v({
  "colors": "jx4o-W_colors",
  "container": "jx4o-W_container",
  "root": "jx4o-W_root",
  "text": "jx4o-W_text",
  "trackGraph": "jx4o-W_trackGraph",
});
